import _regeneratorRuntime from "@babel/runtime-corejs2/regenerator";
import _Promise from "@babel/runtime-corejs2/core-js/promise";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.string.iterator";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "@babel/runtime-corejs2/helpers/esm/asyncToGenerator";
import _classCallCheck from "@babel/runtime-corejs2/helpers/esm/classCallCheck";
import _possibleConstructorReturn from "@babel/runtime-corejs2/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime-corejs2/helpers/esm/getPrototypeOf";
import _assertThisInitialized from "@babel/runtime-corejs2/helpers/esm/assertThisInitialized";
import _inherits from "@babel/runtime-corejs2/helpers/esm/inherits";
import _defineProperty from "@babel/runtime-corejs2/helpers/esm/defineProperty";
import _find from "lodash/find";
import _get from "lodash/get";
import * as React from 'react';
import { adobeTargetOffer } from '../services/adobe-api';
export var ANALYTICS_EVENT_READY = 'analyticsEventReady';
export var ExperienceContext = React.createContext({
  targetOffers: []
});
export var getExperienceOffers = function getExperienceOffers(mbox) {
  var _React$useContext = React.useContext(ExperienceContext),
      targetOffers = _React$useContext.targetOffers;

  var experience = _find(targetOffers, function (experience) {
    return experience.mbox === mbox;
  });

  return _get(experience, 'content');
};
export var isExperienceEnabled = function isExperienceEnabled(mbox) {
  var offers = getExperienceOffers(mbox);
  return isExperienceBOffer(offers);
};
export var isExperienceBOffer = function isExperienceBOffer(offers) {
  return _get(offers, '[0].experienceId') === 'Experience B';
};
export var ExperienceProvider =
/*#__PURE__*/
function (_React$Component) {
  _inherits(ExperienceProvider, _React$Component);

  function ExperienceProvider(props) {
    var _this;

    _classCallCheck(this, ExperienceProvider);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(ExperienceProvider).call(this, props));

    _defineProperty(_assertThisInitialized(_this), "componentDidMount", function () {
      var documentExists = !!window.document;

      var onAnalyticsEventReady = function onAnalyticsEventReady() {
        if (documentExists) {
          window.document.body.removeEventListener(ANALYTICS_EVENT_READY, onAnalyticsEventReady);

          _this.loadComponentData();
        }
      };

      var adobeInitialised = !!_get(window, 'adobe.target.getOffer');

      if (adobeInitialised) {
        _this.loadComponentData();
      } else if (documentExists) {
        window.document.body.addEventListener(ANALYTICS_EVENT_READY, onAnalyticsEventReady);

        if (_this.props.blockRendering) {
          setTimeout(function () {
            // we don't want to block rendering forever if target is not loaded
            window.document.body.removeEventListener(ANALYTICS_EVENT_READY, onAnalyticsEventReady);

            _this.setState({
              initialised: true,
              loading: false
            });
          }, 500);
        }
      } else {
        _this.setState({
          loading: false
        });
      }
    });

    _defineProperty(_assertThisInitialized(_this), "loadComponentData",
    /*#__PURE__*/
    _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee() {
      var _this$props, mboxes, timeout, offers, _targetOffers;

      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _this$props = _this.props, mboxes = _this$props.mboxes, timeout = _this$props.timeout;
              _context.prev = 1;
              _context.next = 4;
              return _Promise.all(mboxes.map(function (mbox) {
                return adobeTargetOffer(mbox, timeout);
              }));

            case 4:
              offers = _context.sent;
              _targetOffers = mboxes.map(function (mbox, index) {
                return {
                  mbox: mbox,
                  content: offers[index]
                };
              });

              _this.setState({
                initialised: true,
                loading: false,
                targetOffers: _targetOffers
              });

              _context.next = 13;
              break;

            case 9:
              _context.prev = 9;
              _context.t0 = _context["catch"](1);

              _this.setState({
                initialised: true,
                loading: false
              });

              console.log(_context.t0);

            case 13:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[1, 9]]);
    })));

    _defineProperty(_assertThisInitialized(_this), "render", function () {
      return React.createElement(ExperienceContext.Provider, {
        value: _this.state
      }, _this.state.initialised && _this.props.children);
    });

    var _mboxes = _this.props.mboxes;
    _this.state = {
      initialised: !props.blockRendering,
      loading: true,
      targetOffers: _mboxes.map(function (mbox) {
        return {
          mbox: mbox,
          content: []
        };
      })
    };
    return _this;
  }

  return ExperienceProvider;
}(React.Component);